<template>
    <div
        class="ResourcesActionItemsBlock grid gap-x-8 gap-y-3 sm:grid-cols-2 sm:gap-3 lg:divide-x"
        :class="{
            'lg:grid-cols-4': fourCols && !minified,
            'lg:grid-cols-3': !fourCols && !minified,
            'lg:divide-gray-400 lg:dark:divide-default': !minified,
            'sm:grid-cols-1': minified
        }"
    >
        <ResourcesActionItem
            v-for="(item, index) in items"
            :key="index"
            :class="{
                'lg:pl-4': index !== 0 && !minified,
                'lg:col-span-2': lastCol(index) && remainingCols === 2,
                'lg:col-span-3': lastCol(index) && remainingCols === 3,
                'lg:col-span-4': lastCol(index) && remainingCols === 4
            }"
            :item="item"
        />
    </div>
</template>

<script setup lang="ts">
import type { ResourcesActionItemType } from '@/components/common/ResourcesActionItem.vue'
import ResourcesActionItem from '@/components/common/ResourcesActionItem.vue'
import type { PropType } from 'vue'
import { computed } from 'vue'

export type ResourcesActionItemsBlockType = ResourcesActionItemType[]

const props = defineProps({
    items: {
        type: Array as PropType<ResourcesActionItemsBlockType>,
        required: true
    },
    fourCols: {
        type: Boolean,
        default: false
    },
    minified: {
        type: Boolean,
        default: false
    }
})

const remainingCols = computed(() => {
    const maxCols = props.fourCols ? 4 : 3
    return maxCols - props.items.length + 1
})

function lastCol(index: number): boolean {
    return index === props.items.length - 1
}
</script>
